import { create } from 'zustand';

type UploadStore = {
  pendingCount: number;
  adImageEventCount: number;
  proofOfAdEventCount: number;
  start: () => void;
  finish: () => void;
  notifyAdImage: () => void;
  notifyProofOfAd: () => void;
};

export const useUploadStore = create<UploadStore>((set) => ({
  pendingCount: 0,
  adImageEventCount: 0,
  proofOfAdEventCount: 0,
  start: () => set((s) => ({ pendingCount: s.pendingCount + 1 })),
  finish: () => set((s) => ({ pendingCount: Math.max(0, s.pendingCount - 1) })),
  notifyAdImage: () => set((s) => ({ adImageEventCount: s.adImageEventCount + 1 })),
  notifyProofOfAd: () => set((s) => ({ proofOfAdEventCount: s.proofOfAdEventCount + 1 })),
}));
